export const getDefaultFilters = (query = '') => ({
  query,
});
